import { SortingType } from 'constants/index';
import { IncidentSearchFields } from './types';

export const DEFAULT_SORT = {
    field: IncidentSearchFields.CASE_STATUS,
    type: SortingType.ASC,
};

// Case.Status / Case.Sub_Status__c are a dependent picklist pair on the Salesforce side.
// Sending a subStatus that isn't valid for the given status is rejected/ignored, so the
// edit form must only ever offer the combinations listed here.
export const CASE_STATUS_SUBSTATUS_MAP: { [status: string]: string[] } = {
    New: ['Incident was reported'],
    'Troubleshooting Phase': [
        'Requested from SP',
        'Technician on Site',
        'Troubleshooting Successful',
        'Troubleshooting Unsuccessful',
    ],
    'Repair Phase': [
        'Technician on Site',
        'Troubleshooting Unsuccessful',
        'Quotation Requested',
        'Quotation Received',
        'Repair Requested',
        'Quotation Rejected',
    ],
    Done: [
        'Troubleshooting Successful',
        'Troubleshooting Unsuccessful',
        'Repair Successful',
        'Repair Unsuccessful',
        'Service provider unable to detect malfunction',
        'IoT report rejected',
        'Parent Case Is Already Reported',
    ],
};

export const CASE_STATUS_OPTIONS: string[] = [
    'New',
    'Troubleshooting Phase',
    'Repair Phase',
    'Done',
    'In Progress',
    'With Customer',
    'Waiting',
    'Waiting for support',
    'Escalated',
    'Inquiry sent',
    'offer received & sent to customer',
    'repair ordered',
    'repaircomplete',
    'Invoice wrong',
    'Invoice corrected',
    'In clarification',
    'Successfully checked',
    'Cancellation invoice',
    'No_contractual_service',
    'No_service_Simplifa',
    'waiting for response',
    'Waiting for Service Provider',
    'Waiting for Customer',
    'Waiting for Simplifa',
    'In Review',
    'Cancelled',
    'Breakdown',
];

